import { Component, inject, Inject } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';
import { TagModule } from 'primeng/tag';

import { ListDto } from '../../clinical-care/core/models/dtos/PendentDto';
import { OrderService } from '../../clinical-care/core/services/api/order.service';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { OrderDetailComponent } from '../../clinical-care/views/order/order-detail/order-detail.component';

@Component({
    selector: 'app-tableloans',
    imports: [TableModule, ButtonModule, RippleModule, TagModule],
    templateUrl: './tableloans.component.html',
    styleUrl: './tableloans.component.scss',
    providers: [DialogService]
})
export class TableloansComponent {
    private _orderService = inject(OrderService);
    filteredOrders: ListDto[] = [];
    listOrder: ListDto[] = [];
    pendingOrders: ListDto[] = [];

    statusOrderList: Array<{ id: number; code: string }> = [];
    statusOrderMap: { [id: number]: string } = {};

    searchOrder: string = '';

    filterStartDate: Date | null = null;
    filterEndDate: Date | null = null;

    constructor(private _dialogService: DialogService) {}

    ngOnInit() {
        this._orderService.getstatuscab().subscribe({
            next: (result) => {
                if (result && Array.isArray(result.data)) {
                    this.statusOrderMap = {};
                    this.statusOrderList = result.data.map((item: any) => {
                        this.statusOrderMap[item.idStatus] = item.code;
                        return { id: item.idStatus, code: item.code };
                    });
                }
            },
            error: (err) => {
                console.error('Error al cargar status ORDER', err);
            }
        });
        this.loadTodayOrders();
    }

    // #region Métodos existentes (sin cambios)
    /**
     * Carga todas las órdenes del día de la sucursal del usuario, incluyendo
     * las generadas desde la sección de laboratorio (no aplica el filtro de
     * categorías de la sección clínica).
     */
    loadTodayOrders() {
        this._orderService.getTodayListOrders().subscribe({
            next: (res) => {
                const allOrders = res.data || [];
                this.filteredOrders = allOrders;
                this.pendingOrders = allOrders.filter(o =>
                    (o.orderDetail || []).some(d => (d.fileCount ?? 0) === 0)
                );
            },
            error: () => {
                this.filteredOrders = [];
                this.pendingOrders = [];
            }
        });
    }

    getOrderStatusCodeById(id: number): string {
        return this.statusOrderMap[id] || '';
    }

    openOrderDetail(order: ListDto): void {
        const ref: DynamicDialogRef | null = this._dialogService.open(OrderDetailComponent, {
            header: `Detalle de Orden: ${order.codOrder}`,
            width: '60vw',
            height: 'auto',
            contentStyle: { overflow: 'auto' },
            baseZIndex: 10000,
            maximizable: false,
            closable: true,
            data: {
                idOrder: order.idOrder
            }
        });
    }
}
